function ProjectTools(tool) {
  const arra = tool.tool.split(" ");
  const tools = arra.map((ele, idx) => (
    <img
      src={ele}
      alt=""
      key={idx}
      width="40px"
      style={{ paddingRight: "10px" }}
    />
  ));

  return <>{tools}</>;
}

export default ProjectTools;
